// @ts-check
import axios from 'axios';
import config from '../constants/config';

const ticketsAxios = axios.create();
const ticketsService = {};

/**
 * Get all tickets list
 * Dates should be ISO strings
 * @param {import('../../../types/common').PaginationOptions} params
 * @returns
 */
ticketsService.getTicketsList = (params) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = user?.token || '';
  const url = `${config.BASEURL}v2/tickets/`;
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return ticketsAxios.get(url, { headers, params });
};

export default ticketsService;
